module.exports = __webpack_public_path__ + "media/images/icons/british-pound-07fbc8c055743d6c257db590ffc48512.svg";